'use client'

import { Component } from 'react'
import Link from 'next/link'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
          <div className="max-w-sm w-full bg-white rounded-2xl shadow-md p-8 text-center">
            <div className="text-4xl mb-4">✈️</div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h2>
            <p className="text-gray-500 text-sm mb-6">
              We hit a turbulence. Please refresh the page to get back on track.
            </p>
            <div className="flex flex-col gap-2">
              <button
                onClick={() => { this.setState({ hasError: false }); window.location.reload() }}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg px-4 py-2.5 transition-colors text-sm"
              >
                Refresh page
              </button>
              <Link
                href="/"
                className="w-full block bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-lg px-4 py-2.5 transition-colors text-sm text-center"
              >
                Go to homepage
              </Link>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
